"use strict";
// @ts-nocheck
/**
 * extracted from ad-config - configureBidders 324
 *
 * covers:
 * *
 * TODOS:
 * * Add back test group GDPR_ADS_EXPERIENCE
 * * Add back test group EXCLUDE_PREBID_PARTNERS
 * * Add back test group userDeviceType
 * * Add back test group userCountry
 * * Add back test group isInGDPRFilter
 * * Add back test group onlyInCountryFilter
 * * Add back test group isExcludedByDeviceAndCountry
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureBidders = void 0;
var getBidderList_1 = require("./getBidderList");
// generate list of bidders based on any eligibility criteria required
function configureBidders(placement, testGroups, userGeo, userDeviceType) {
    var isInGdprGeo = testGroups.GDPR_ADS_EXPERIENCE;
    var shouldExcludeBidders = testGroups.EXCLUDE_PREBID_PARTNERS;
    var available_bidders = (0, getBidderList_1.getBidderList)(placement, testGroups);
    var reqParams = {
        rubicon: ["accountId", "siteId", "zoneId"],
        shemedia: ["accountId", "siteId", "zoneId"],
        pubmatic: ["publisherId", "adSlot"],
        criteo: ["networkId"],
        triplelift: ["inventoryCode"],
        sovrn: ["tagid"],
        sharethrough: ["pkey"],
        ix: ["siteId", "size"],
        "33across": ["siteId"],
    };
    var hasValidConfig = function (bidder) {
        var config = bidder["config"];
        var valid = true;
        reqParams[config["bidder"]].forEach(function (param) {
            if (!config.params.hasOwnProperty(param) || !config.params[param]) {
                valid = false;
            }
        });
        return valid;
    };
    var isInGDPRFilter = function (bidder) {
        return !isInGdprGeo || bidder.gdprEnabled;
    };
    var onlyInCountryFilter = function (bidder) {
        // Check if bidder has onlyInCountry
        if (!bidder.onlyInCountry) {
            return true;
        }
        else {
            //Bidder has onlyInCountry so return if the value contains users country
            return bidder.onlyInCountry.includes(userGeo);
        }
    };
    var isExcludedByDeviceAndCountry = function (bidder) {
        //Check user device and country on exclude list
        var excludedCountries = bidder.exclude[userDeviceType] || [];
        return shouldExcludeBidders && excludedCountries.includes(userGeo);
    };
    var reducer = function (accumulator, currentValue) {
        if (hasValidConfig(currentValue) &&
            isInGDPRFilter(currentValue) &&
            !isExcludedByDeviceAndCountry(currentValue) &&
            onlyInCountryFilter(currentValue)) {
            accumulator.push(currentValue.config);
        }
        return accumulator;
    };
    return available_bidders.reduce(reducer, []);
}
exports.configureBidders = configureBidders;
